export default __webpack_public_path__ + "static/media/icon-vehicle-dispatch.5b7b428a.svg";